<template>
  <modal
    :title="clientName"
    size="sm"
    ref="modal"
  >
    <q-tabs
            v-model="tab"
            dense
            class="text-grey-8"
            active-color="primary"
            indicator-color="primary"
            align="justify"
            narrow-indicator
    >
        <q-tab name="assigned" label="Assigned" />
        <q-tab name="unassigned" label="Unassigned" />
    </q-tabs>

    <q-separator />

    <q-tab-panels v-model="tab" animated>
        <q-tab-panel name="assigned">
            <assigned-client-users :client="client" />
        </q-tab-panel>
        <q-tab-panel name="unassigned">
            <unassigned-client-users :client="client" />
        </q-tab-panel>
    </q-tab-panels>
  </modal>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { ModalMixin } from '@/mixins';
import { Client } from '@/type';
import Modal from '@/components/modal/Modal.vue';
import AssignedClientUsers from '@/client-user/AssignedClientUsers.vue';
import UnassignedClientUsers from '@/client-user/UnassignedClientUsers.vue';

interface Data {
  tab: string,
}

export default defineComponent({
  mixins: [ModalMixin],
  components: {
    Modal,
    AssignedClientUsers,
    UnassignedClientUsers,
  },
  props: {
    client: {
      type: Object as () => Client,
      required: true,
    },
  },
  computed: {
    clientName(): string {
      return this.client ? `${this.client.lastName}, ${this.client.firstName}` : '';
    },
  },
  data(): Data {
    return {
      tab: 'assigned',
    };
  },
});
</script>
